module.exports = __webpack_public_path__ + "static/media/website-faq2.4fb1fec2.png";